var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"rules":_vm.internalRules,"type":"number","label":_vm.label,"outlined":"","clearable":""},model:{value:(_vm.numericValue),callback:function ($$v) {_vm.numericValue=_vm._n($$v)},expression:"numericValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }